import { IdentityType } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/workflows_pb";

import { Validator } from "./validator";

export const isEmaillessUser = (user: { email?: string }): boolean =>
  new Validator().validateEmail(user.email ?? "") !== undefined;

export const classifyIdentity = (value: string): IdentityType => {
  return new Validator().validateEmail(value) === undefined
    ? IdentityType.EMAIL
    : IdentityType.USERNAME;
};
